var _rect, _rect2, _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentOptional = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 28,
    height: 21,
    fill: "#EDF4FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 10,
    height: 21,
    fill: "#EDF4FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 0C3.86057 0 2.66667 1.19391 2.66667 2.66667V4C2.66667 4.07555 2.66981 4.15037 2.67597 4.22433C1.11752 4.77081 0 6.2549 0 8V24C0 26.2091 1.79086 28 4 28H28C30.2091 28 32 26.2091 32 24V8C32 5.79086 30.2091 4 28 4H15.832C15.2399 1.6997 13.1518 0 10.6667 0H5.33333ZM12.9766 4C12.5155 3.20293 11.6537 2.66667 10.6667 2.66667H5.33333V4H12.9766ZM4 6.66667C3.26362 6.66667 2.66667 7.26362 2.66667 8V24C2.66667 24.7364 3.26362 25.3333 4 25.3333H28C28.7364 25.3333 29.3333 24.7364 29.3333 24V8C29.3333 7.26362 28.7364 6.66667 28 6.66667H4Z",
    fill: "#B9D5F7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4138,
    cy: 24.4138,
    rx: 6.41379,
    ry: 6.41379,
    fill: "#F5B63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3276 21.3447C28.086 21.3447 27.8901 21.5406 27.8901 21.7822V24.4072H25.2651C25.0235 24.4072 24.8276 24.6031 24.8276 24.8447C24.8276 25.0864 25.0235 25.2822 25.2651 25.2822H27.8901V27.9072C27.8901 28.1489 28.086 28.3447 28.3276 28.3447C28.5693 28.3447 28.7651 28.1489 28.7651 27.9072V25.2822H31.3901C31.6318 25.2822 31.8276 25.0864 31.8276 24.8447C31.8276 24.6031 31.6318 24.4072 31.3901 24.4072H28.7651V21.7822C28.7651 21.5406 28.5693 21.3447 28.3276 21.3447Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentOptional);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/documentOptional.133de5842ec5ba6210e520823bc898f5.svg";